import gql from 'graphql-tag';
import companyFragment from './moveiq-company';

const NAME = 'moveIqReservation';
const FRAGMENT = `fragment ${NAME} on MoveIqReservation {
  company {
    ...${companyFragment.name}
  }
  date
  id
  includePacking
  moveId
  price
  status
  topValue
  valueScore
  valueTier
}
${companyFragment.fragment}
`;

export default {
  fragment: FRAGMENT,
  name: NAME,
  gql: gql`
    ${FRAGMENT}
  `,
};
